module.exports = __webpack_public_path__ + "img/price-quote4.0bed2c32.png";